import { toArray } from 'lodash';
import { Controller } from 'stimulus';
import Swiper from 'swiper';

const expectedSizes = [
  {
    scale: 1.44,
    align: 'center',
  },
  {
    scale: 1,
    align: 'bottom',
  },
  {
    scale: 1.88,
    align: 'center',
  },
  {
    scale: 1,
    align: 'top',
  },
];

function looped(index, array) {
  // eslint-disable-next-line no-mixed-operators
  return array[(index % array.length + array.length) % array.length];
}

class BubbleSlider extends Controller {
  connect() {
    this.duplicateSlidesForLoop();

    this.swiper = new Swiper(this.swiperTarget, {
      slidesPerView: 'auto',
      loop: true,
      loopAdditionalSlides: 10,
    });

    this.slideWidth = this.swiper.slides[0].offsetWidth;

    this.swiper.on('setTranslate', () => {
      // this.calculateSlidePositions();
    });

    this.swiper.on('transitionEnd', () => {
      // this.calculateSlidePositions();
    });

    this.calculateSlidePositions();
    this.applyCentering(this.swiper.isLocked);
  }

  onWindowResize() {
    this.slideWidth = this.swiper.slides[0].offsetWidth;

    this.calculateSlidePositions();
    this.applyCentering(this.swiper.isLocked);
  }

  onPrevClick() {
    this.swiper.slidePrev();
  }

  onNextClick() {
    this.swiper.slideNext();
  }

  calculateSlidePositions() {
    const { slides } = this.swiper;

    const sliderLeft = this.swiper.el.getBoundingClientRect().left;

    // if (slides.length === 1) {
    //   expectedSizes.push({
    //     scale: 1.88,
    //     align: 'center',
    //   });
    // }

    slides.forEach((slide, i) => {
      const slideLeft = slide.getBoundingClientRect().left;
      const bubble = slide.querySelector('.bubbles-header__bubble');
      const bubbleContents = slide.querySelector('.bubbles-header__bubble-content');

      // Retrieve the offset of this slide from the left of the full slider.
      const offsetFromLeft = slideLeft - sliderLeft;

      // If the Swiper is locked, it means that it does not loop, use the default index
      // Otherwise calculate the index based on the position of the slide relative to the slider.
      const activeIndex = this.swiper.isLocked
        ? i
        : Math.round(offsetFromLeft / this.slideWidth);

      bubble.dataset.activeIndex = activeIndex;

      // Retrieve the configuration for this slide index. The looped call makes sure
      // that it will always return a config item. Looped example:
      // looped(4, [0, 1, 2]) => 1
      const configForIndex = looped(activeIndex, expectedSizes);

      const { scale } = configForIndex;

      // Scale the bubble
      bubble.style.transform = `scale(${scale})`;

      // Because the content is in the bubble, it scales to quite a large
      // size. We want to scale the content down based on the scale of
      // the bubble.
      // For example, if the bubble scale is 2, the content scale will
      // be: ~0.69
      const contentsScale = 1 / (((scale - 1) / 2) + 1);

      // Scale the bubble contents
      bubbleContents.style.transform = `scale(${contentsScale})`;

      // Set the alignment of the bubble as data attribute. CSS will use
      // it to move the bubble to the top, bottom or center (vertically).
      bubble.dataset.align = configForIndex.align;
    });
  }

  applyCentering(shouldCenter) {
    const wrapper = this.swiperTarget.querySelector('.swiper-wrapper');

    // By setting width to 'auto', flex will automatically horizontally center the items.
    wrapper.style.width = shouldCenter ? 'auto' : '100%';

    // Retrieve the pagination buttons (prev/next) as an array of nodes
    const paginateItems = Array.prototype.slice.call(
      this.element.querySelectorAll('.bubbles-header__paginate'),
    );

    // Show/hide pagination buttons based on if the slider is looping
    paginateItems.forEach((paginateItem) => {
      paginateItem.classList[shouldCenter ? 'remove' : 'add']('is-active');
    });
  }

  /**
   * This is an issue with Swiper that does not allow looping if the number of slides
   * is smaller than the slidesPerView * 2.
   * Source: https://github.com/nolimits4web/swiper/issues/6600
   *
   * For example, if we've slides of 200 pixels wide and your screen is 1200 pixels wide,
   * we can fit 6 slides. But for it to loop, we need 6 * 2 = 12 slides.
   *
   * This function retrieves the width on the first slide, calculates how many we need for
   * looping, and then duplicates the slides to reach it.
   */
  duplicateSlidesForLoop() {
    const slides = toArray(this.swiperTarget.querySelectorAll('.swiper-slide'));

    if (!slides.length) {
      return;
    }

    // Retrieve the width on the first slide
    const slideWidth = slides[0].offsetWidth;

    // Get the width we've to fill with slides. Add an additional 500 pixels, to be safe.
    const maxWidthToAccountFor = this.swiperTarget.offsetWidth + 500;

    // Calculate the number of required slides to fill the width
    const requiredSlides = Math.ceil(maxWidthToAccountFor / slideWidth) * 2;

    // If we already have enough slides, return
    if (requiredSlides < slides.length) {
      return;
    }

    // Calculate how many times we've to duplicate the slides
    const duplicatesRequired = Math.ceil(requiredSlides / slides.length) - 1;

    for (let i = 0; i < duplicatesRequired; i += 1) {
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        this.swiperTarget.querySelector('.swiper-wrapper').appendChild(clone);
      });
    }
  }
}

BubbleSlider.targets = [
  'row',
  'prev',
  'next',
  'swiper',
];

export default BubbleSlider;
